<template>
  <div>
    <div class="bk-blue secret-blue">
      <div class="container">

        <h2><span>Secretul 1<br></span>Oligozaharidele din laptele matern</h2>
        <p>Unul dintre ingredientele esențiale ale laptelui matern sunt oligozaharidele din laptele matern, pe cât
          de necunoscute, pe atât de importante. Să înțelegem împreună
          <span>ce sunt oligozaharidele din laptele matern:</span>
        </p>

      </div>
    </div>
    <div class="secret-white ">
      <div class="container secret-container">
        <div class="row">
          <div class="secret--container-quote col-2">
            <img src="../../assets/images/image-secretele-laptelui/quote.png" alt="/">
          </div>
          <div class="secret--container-content col-10">
            <p>Oligozaharidele din laptele matern sunt carbohidrați care apar în mod natural în laptele
              matern. Cantitativ, oligozaharidele sunt al treilea cel mai abundent ingredient din compoziția laptelui
              matern, după lactoză și lipide. Într-un litru de lapte matern se află între 5-15g de oligozaharide.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
}
</script>
<style scoped lang="scss">


</style>
